<template>
  <transition name="fade">
    <div>
      <b-button
        ref="vipUnlockedBtn"
        v-if="profile.influencer.has_vip_access"
        class="btn-black p-2 px-3 radius-10 float-left v-center"
        style="min-height: 47px"
        disabled
      >
        <b-img
          src="~@/assets/img/unlocked.svg"
          class="d-inline-block float-left pr-2 mt-n1"
          height="22px"
        />
        <p class="d-inline-block text-left m-0">
          <span class="d-block">
            <strong class="text-gold">VIP Unlocked</strong>
          </span>
        </p>
      </b-button>

      <b-button
        ref="vipSubscribeUnlockBtn"
        v-else-if="isVipPackEnabled"
        class="btn-gold radius-10 v-center p-1 pl-2 px-2"
        style="min-width: 150px; min-height: 47px"
        v-b-modal.vipAccessForm
      >
        <b-img
          src="~@/assets/img/locked.svg"
          class="d-inline-block float-left ml-1 mr-2"
          height="25px"
        />
        <p class="d-inline-block m-0 text-left pl-1">
          <span class="d-block">
            <strong>VIP Access</strong>
          </span>
          <small class="d-block text-white-50 mt-n2">
            <small> Subscribe to unlock </small>
          </small>
        </p>
      </b-button>

      <!-- MODAL FORM -->
      <vip-access-modal />
    </div>
  </transition>
</template>

<script>
import { mapState } from 'vuex'
import VipAccessModal from './VipAccessModal'

export default {
  name: 'VipAccessButton',
  components: {
    VipAccessModal,
  },
  computed: {
    ...mapState({
      profile: (state) => state.influencer.profile,
    }),

    isVipPackEnabled() {
      return this.profile.influencer.package_settings.is_vip_pack_enabled
    },
  },
  methods: {},
}
</script>

<style scoped></style>
